// Product Recommendations Component
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.init();
  }

  init() {
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: load immediately if IntersectionObserver not supported
      this.loadRecommendations();
      return;
    }

    const options = {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.01
    };

    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry && entry.isIntersecting) {
        this.observer.unobserve(this);
        this.loadRecommendations();
      }
    }, options);

    this.observer.observe(this);
  }

  async loadRecommendations() {
    const url = this.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        
        // Check if content was loaded successfully
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      }
    } catch (error) {
      // Error handled silently - component will remain in loading state
      console.debug('Product recommendations failed to load:', error);
    }
  }

  disconnectedCallback() {
    // Clean up observer when element is removed
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// Only define if not already defined (prevents duplicate definitions)
if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}



